const cache = new Map<string, { data: any; timestamp: number }>()

const CACHE_TTL = 10 * 60 * 1000

export const withCache = async (key: string, fetcher: () => Promise<any>) => {
  const cached = cache.get(key)

  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    console.log(`Cache HIT: ${key}`)
    return cached.data
  }

  console.log(`Cache MISS: ${key}`)
  const data = await fetcher()
  cache.set(key, { data, timestamp: Date.now() })
  return data
}
